import React, { useState, useEffect } from "react";
import { Icon, Button} from "../../../components/Component";
import { getDateFormat } from "../../../utils/Utils";
import { useSelector, useDispatch } from 'react-redux';
import {useMediaQuery, useMediaQueries} from '@react-hook/media-query';
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import SearchComponent from "./SearchComponent";
// import "../../../assets/css/style.css";

const TableHeadMini = ({
    searchHandler,
    searchFieldData,
    seachFeildType,
    reloadHandler,
    setSearchText,
    setSelectedItems,
    checkResponse,
    setCurrentPage,
    pageName,
    showDatePicker=false,
    showSearchBar=true,
}) => {

    
    const [onSearch, setonSearch] = useState(showSearchBar);
    const [onRefreshPage, setOnRefreshPage] = useState(false);
    const key = Object.keys(searchFieldData);
    let updatedSearchFieldData = {};
    {
        key.map((field, i) => {
            updatedSearchFieldData[field] = "";
        });
    }

    const [state, setState] = useState(updatedSearchFieldData);
    const [rangeStart, setRangeStart] = useState();
    const [rangeEnd, setRangeEnd] = useState();
    


    useEffect(() => {
        setState({ ...searchFieldData });
        setRangeStart('');
        setRangeEnd('');
        setOnRefreshPage(true);
    }, [checkResponse])

    useEffect(() => {
        setState({
            ...state,
            ["startDate"]: "",
            ["endDate"]: "",
        });
    }, []);


  useEffect(() => {
    setState({
      ...state,
      ["startDate"]: rangeStart !== undefined ? getDateFormat(rangeStart) : "",
    });
  }, [rangeStart]);

  useEffect(() => {
    setState({
      ...state,
      ["endDate"]: rangeEnd !== undefined ? getDateFormat(rangeEnd) : "",
    });
  }, [rangeEnd]);


    useEffect(() => {
        setOnRefreshPage(false);
        setState({ ...searchFieldData });
    }, [onRefreshPage]);

    const onEnterHandler = (e) => {
        if (e.key === "Enter") {
            searchHandler(state);
        }
    };  

  
  const [searchModal, setSearchModal] = useState(false);    

  const toggleSearchModal = () => {
      setSearchModal(!searchModal);
  };

    return (
        <>

                   
{/* <Button
                        onClick={toggleSearchModal}
                        className="search-submit btn btn-icon btn-primary"
                    >
                        <Icon name="search"></Icon>
                    </Button> */}

                    <button onClick={toggleSearchModal} className="btn btn-icon btn-sm btn-primary ml-2">
                        <Icon name="search"></Icon>
                    </button>

            <Modal
            isOpen={searchModal}
            toggle={toggleSearchModal}
            size="lg"
            fade={false}
            // backdrop={'static'}
            className="search-modal-dialogue"
        >
            

            <ModalBody>
            <button className="close" onClick={toggleSearchModal}>
                    <Icon name="cross" />
                </button>

                <SearchComponent   
                    searchHandler={searchHandler}
                    searchFieldData={searchFieldData}
                    seachFeildType={seachFeildType}
                    reloadHandler={reloadHandler}
                    setSearchText={setSearchText}
                    setSelectedItems={setSelectedItems}
                    checkResponse={checkResponse}
                    setCurrentPage={setCurrentPage}
                    pageName={pageName}
                    showDatePicker={showDatePicker}
                    showSearchBar={showSearchBar}  
                    toggle={() => {}}
                    toggleSearchModal={toggleSearchModal}                           
                    />

            </ModalBody>

        </Modal>

        </>
    );
};

export default TableHeadMini;